import { Component, OnDestroy, OnInit } from '@angular/core';


import { MainLayoutComponent } from 'src/app/shared/components/main-layout/main-layout.component';
import { BlogPostCardComponent } from 'src/app/shared/components/blog-post-card/blog-post-card.component';
import { DataService } from 'src/app/services/data.service';
import { BrandService } from 'src/app/services/brand.service';
import { Subscription } from 'rxjs';
import { TOPICS } from 'src/app/shared/constants/constants';
import { BlogPost } from 'src/app/services/data.model';
import { BrandKey } from 'src/app/shared/constants/brand.constants';

@Component({
  selector: 'app-do-not-service-area',
  standalone: true,
  imports: [
    MainLayoutComponent,
    BlogPostCardComponent
],
  templateUrl: './do-not-service-area.component.html',
  styleUrl: './do-not-service-area.component.scss',
})
export class DoNotServiceAreaComponent implements OnInit, OnDestroy {
  name: string = '';
  brandKey: BrandKey = 'windownation';
  blogPosts: BlogPost[] = [
    {
      unique_name: TOPICS.ENERGY_EFFICIENCY,
      title: 'Energy Efficiency',
      text: '<p>We sell some of the most energy efficient windows - that could lower your monthly utility bills</p>',
      image: {
        description: 'Woman adjusting her Thermostat',
        url: 'assets/images/energy-efficiency.jpg',
      },
      read_more_button: {
        text: 'Read More',
        link: 'energy-efficiency',
      },
    },
  ];
  sub: Subscription;

  constructor(
    private dataService: DataService,
    private brandService: BrandService,
  ) {}

  ngOnInit() {
    const stepsData = { ...this.dataService.stepsData };
    stepsData.status = 'Abandoned';
    this.sub = this.dataService.saveStepsData(stepsData).subscribe();
    this.name = this.dataService.username;
    this.brandKey = this.brandService.getCurrentBrandKey();
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }
}
